import { Separator } from "@/components/ui/separator";
import ApplicationList from "./application-list";
import UserHeading from "./user-heading";
import WelcomeAlert from "./welcome-alert";

const HomePage = () => {
  return (
    <>
      <UserHeading />

      <Separator className="my-4" />

      <WelcomeAlert className="mb-4" />

      <ApplicationList />
    </>
  );
};

export default HomePage;
